module.exports = __webpack_public_path__ + "img/alipay.9459d51a.png";